var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 12.5C11.3807 12.5 12.5 11.3807 12.5 10C12.5 8.61929 11.3807 7.5 10 7.5C8.61929 7.5 7.5 8.61929 7.5 10C7.5 11.3807 8.61929 12.5 10 12.5Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.66699 10.7333V9.26666C1.66699 8.4 2.37533 7.68333 3.25033 7.68333C4.75866 7.68333 5.37533 6.61666 4.61699 5.30833C4.18366 4.55833 4.44199 3.58333 5.20033 3.15L6.64199 2.325C7.30033 1.93333 8.15033 2.16666 8.54199 2.825L8.63366 2.98333C9.38366 4.29166 10.617 4.29166 11.3753 2.98333L11.467 2.825C11.8587 2.16666 12.7087 1.93333 13.367 2.325L14.8087 3.15C15.567 3.58333 15.8253 4.55833 15.392 5.30833C14.6337 6.61666 15.2503 7.68333 16.7587 7.68333C17.6253 7.68333 18.342 8.39166 18.342 9.26666V10.7333C18.342 11.6 17.6337 12.3167 16.7587 12.3167C15.2503 12.3167 14.6337 13.3833 15.392 14.6917C15.8253 15.45 15.567 16.4167 14.8087 16.85L13.367 17.675C12.7087 18.0667 11.8587 17.8333 11.467 17.175L11.3753 17.0167C10.6253 15.7083 9.39199 15.7083 8.63366 17.0167L8.54199 17.175C8.15033 17.8333 7.30033 18.0667 6.64199 17.675L5.20033 16.85C4.44199 16.4167 4.18366 15.4417 4.61699 14.6917C5.37533 13.3833 4.75866 12.3167 3.25033 12.3167C2.37533 12.3167 1.66699 11.6 1.66699 10.7333Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.975f0aabacba41c5f77fa675644a1f5c.svg";
export { ForwardRef as ReactComponent };